/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Tab_BenchmarksInputs */

const en_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks`)
};

const de_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks`)
};

const fr_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparatifs`)
};

const es_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparativas`)
};

const it_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronti`)
};

const nl_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijkingen`)
};

const pl_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarki`)
};

const fi_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertailuarvot`)
};

const da_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenligninger`)
};

const sv_salary_tab_benchmarks = /** @type {(inputs: Salary_Tab_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämförelser`)
};

/**
* | output |
* | --- |
* | "Benchmarks" |
*
* @param {Salary_Tab_BenchmarksInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_tab_benchmarks = /** @type {((inputs?: Salary_Tab_BenchmarksInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Tab_BenchmarksInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_tab_benchmarks(inputs)
	if (locale === "fr") return fr_salary_tab_benchmarks(inputs)
	if (locale === "es") return es_salary_tab_benchmarks(inputs)
	if (locale === "it") return it_salary_tab_benchmarks(inputs)
	if (locale === "nl") return nl_salary_tab_benchmarks(inputs)
	if (locale === "pl") return pl_salary_tab_benchmarks(inputs)
	if (locale === "fi") return fi_salary_tab_benchmarks(inputs)
	if (locale === "da") return da_salary_tab_benchmarks(inputs)
	if (locale === "sv") return sv_salary_tab_benchmarks(inputs)
	return en_salary_tab_benchmarks(inputs)
});